<div
  *ngIf="!isAvailable; else price"
  class="alert alert-info alert-primary mb-24"
>
  <div class="alert-content grid align-items-center">
    <div class="alert-message">
      В настоящее время недоступно для заказа в вашем регионе.
    </div>
  </div>
</div>

<div *ngIf="showMobile" @flyInOut class="mobile-price hidden block-sm">
  <ng-container *ngTemplateOutlet="price"></ng-container>
</div>

<ng-template #price>
  <div *ngIf="item" class="card card-border-1 full-width mb-24">
    <div class="card-body">
      <div class="grid justify-content-between align-items-center">
        <div class="grid-item">
          <div class="typography typography-headline">Cтоимость:</div>
          <div class="typography typography-huge">
            {{ item.price }} {{ item.currency?.symbol }}
          </div>
        </div>
        <div class="grid-item">
          <button
            [disabled]="inCart$ | async"
            class="button button-primary"
            style="min-width: auto"
            appPreventDoubleclick
            (throttledClick)="addToCart()"
            [throttleTime]="1000"
          >
            <span *ngIf="inCart$ | async">В корзине</span>
            <span *ngIf="!(inCart$ | async)" class="hidden-lg"
              >Заказать анализ</span
            >
            <span *ngIf="!(inCart$ | async)" class="hidden block-lg"
              >Заказать</span
            >
          </button>
        </div>
      </div>
      <div class="divider" *ngIf="item.servicePrice"></div>
      <div
        class="grid grid-gutter-8 align-items-center"
        *ngIf="item.servicePrice"
      >
        <div class="grid-item typography typography-caption">
          Взятие биоматериала:
        </div>
        <div class="grid-item">
          <span
            *ngIf="item.servicePrice.canCostBeHigher"
            class="typography typography-caption mr-2"
          >
            от
          </span>
          <div class="tag">
            {{ item.servicePrice.minimalServicesCost }}
            {{ item.currency?.symbol }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
